module.exports = __webpack_public_path__ + "static/organic-search-row-six-hero-4-50c36af543632ebe15f9a0690b076fed.png";